import { Link } from 'react-router-dom';
import type { ArticleItem } from '@/mocks/articles';

interface ArticleCardProps {
  article: ArticleItem;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full sm:w-48 h-32 flex-shrink-0 rounded-lg overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="flex flex-col justify-between flex-1 min-w-0">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs bg-accent-100 text-accent-800 px-2 py-0.5 rounded whitespace-nowrap">
              {article.category}
            </span>
            <span className="text-xs text-foreground-400">{article.publishDate}</span>
          </div>
          <h3 className="text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-accent-600 transition-colors">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-500 line-clamp-2 mt-1">
            {article.excerpt}
          </p>
        </div>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-user-line w-3 h-3 flex items-center justify-center" />
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line w-3 h-3 flex items-center justify-center" />
            {article.views.toLocaleString()}
          </span>
        </div>
      </div>
    </Link>
  );
}